import React from 'react';
import { DEFAULT_THUMBNAIL, MARKER_TYPES } from '../../../../shared/helpers/markers';

export default class PreviewPlayer extends React.PureComponent {
  constructor(props) {
    super(props);

    this.state = {
      isBig: false,
      currentImageUrl: '',
    };
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    this.updateCurrentImageUrl(nextProps);
  }

  updateCurrentImageUrl({ audioProgress, markers, isPlayingAdJingle }) {
    const lastPassedNonAdMarker = markers.find(
      marker =>
        marker.type !== MARKER_TYPES.AD &&
        marker.type !== MARKER_TYPES.AUDIO &&
        marker.start <= audioProgress &&
        marker.start + marker.duration > audioProgress
    );

    this.setState({
      currentImageUrl:
        !isPlayingAdJingle && lastPassedNonAdMarker
          ? lastPassedNonAdMarker.thumbnail.original
          : DEFAULT_THUMBNAIL,
    });
  }

  toggleSize = () => {
    this.setState(({ isBig }) => ({ isBig: !isBig }));
  };

  render() {
    return (
      <div
        className={`preview-player ${
          this.state.isBig ? 'preview-player--big' : 'preview-player--small'
        }`}
        onClick={this.toggleSize}
        style={{ backgroundImage: `url(${this.state.currentImageUrl})` }}
      />
    );
  }
}
